module.exports = __webpack_public_path__ + "media/1_start.94e2192a.mp3";